
import React from "react";
import { LucideIcon } from "lucide-react";

interface CardContactItemProps {
  icon: LucideIcon;
  content: string;
  type: "phone" | "address" | "email" | "website";
}

export function CardContactItem({ icon: Icon, content, type }: CardContactItemProps) {
  // Format address to be more readable on mobile with appropriate line breaks
  const formatAddress = (address: string) => {
    return address
      .split(",")
      .map((part) => part.trim())
      .join(", ");
  };

  let displayContent = content;
  if (type === "address") {
    displayContent = formatAddress(content);
  }

  let href = "";
  let target = "_blank";
  let rel = "noopener noreferrer";

  switch (type) {
    case "phone":
      href = `tel:${content.replace(/\s+/g, "")}`;
      break;
    case "email":
      href = `mailto:${content}`;
      break;
    case "website":
      href = content.startsWith("http") ? content : `https://${content}`;
      break;
    case "address":
      href = `https://maps.google.com/?q=${encodeURIComponent(content)}`;
      break;
    default:
      break;
  }

  return (
    <div className="flex items-start gap-2">
      <div className="bg-grandpal-beige rounded-full p-1.5 mt-0.5 flex-shrink-0">
        <Icon className="h-4 w-4 text-grandpal-green" />
      </div>
      <a
        href={href}
        target={target}
        rel={rel}
        className="text-sm text-gray-600 leading-tight hover:underline break-words"
        onClick={(e) => e.stopPropagation()}
      >
        {displayContent}
      </a>
    </div>
  );
}
